export const SET_IS_GENERATING_STREAM_DATA = 'SET_IS_GENERATING_STREAM_DATA';
